module.exports = __webpack_public_path__ + "common/tp-featured8-64e8ab995a0a4df1b4f7efd9f2c1a50e.svg";